import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import DashFrame from '~/layout/DashFrame';
import HomePage from '~/pages/Home';
import Payment from '~/pages/Payment';
import PaymentConfirm from '~/pages/PaymentConfirm';
import PersonalCoverage from '~/pages/PersonalCoverage';
import Contract from '~/pages/contract';
import CardChangeRoute from '~/pages/contract/config/CardChangeRoute';
import ContractDownload from '~/pages/contract/download';
import ContractRenewal from '~/pages/contract/renewal/RenewalRoute';
import { RenewalSuccess } from '~/pages/contract/renewal/success';
import ContractStep1 from '~/pages/contract/step1';
import ContractStep2 from '~/pages/contract/step2';
import ContractStep3 from '~/pages/contract/step3';
import ContractStep4 from '~/pages/contract/step4';
import ContractStep5 from '~/pages/contract/step5';
import ContractStep6 from '~/pages/contract/step6';
import useStore from '~/store';
import AppBootstrapScreen from './AppBootstrapScreen';
import { usePosthogPageviews } from '~/analytics/usePosthogPageviews';

// import PublicRoute from './PublicRoute'

const RoutesApp: React.FC = () => {
  usePosthogPageviews();
  // const location = useLocation()
  // const state = location.state as { backgroundLocation?: Location }
  const { getClientCredencial, clientCredencial, clientCredencialLoading, clientCredencialError } = useStore(
    (store) => ({
      getClientCredencial: store?.getClientCredencial,
      clientCredencial: store?.clientCredencial,
      clientCredencialLoading: store?.clientCredencialLoading,
      clientCredencialError: store?.clientCredencialError
    })
  );
  useEffect(() => {
    (async () => {
      getClientCredencial(null);
    })();
  }, []);

  if (!clientCredencial) {
    return (
      <AppBootstrapScreen
        onRetry={() => getClientCredencial(null)}
        state={clientCredencialError && !clientCredencialLoading ? 'error' : 'loading'}
      />
    );
  }

  return (
    <>
      {clientCredencial && (
        <>
          <Routes>
            <Route path="">
              <Route index element={<HomePage />} />
              {/* <Route path="personalCoverage" element={<PersonalCoverage />} /> */}
            </Route>
            <Route path="personalCoverage" element={<DashFrame />}>
              <Route index element={<PersonalCoverage />} />
            </Route>
            <Route path="payment" element={<DashFrame />}>
              <Route index element={<Payment />} />
            </Route>
            <Route path="paymentConfirm" element={<DashFrame />}>
              <Route index element={<PaymentConfirm />} />
            </Route>
            <Route path="contract" element={<DashFrame />}>
              <Route index element={<Contract />} />
              <Route path="user" element={<ContractStep1 />} />
              <Route path="address" element={<ContractStep2 />} />
              <Route path="equipment" element={<ContractStep3 />} />
              <Route path="file" element={<ContractStep4 />} />
              <Route path="emergency" element={<ContractStep5 />} />
              <Route path="download" element={<ContractStep6 />} />
              <Route path="renewal/:contractId" element={<ContractRenewal />} />
              <Route path="renewal/success/:contractId" element={<RenewalSuccess />} />
              <Route path=":contractId" element={<CardChangeRoute />} />
              <Route path=":contractHash/download" element={<ContractDownload />} />
            </Route>
          </Routes>
        </>
      )}
    </>
  );
};

export default RoutesApp;
